<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<div class="searchbox">
			<el-input style="width:160px;margin-right: 10px;" placeholder="请输入名称" v-model="params.keyword"
				@keyup.enter.native="clickSearch" clearable size="small"></el-input>
			<el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
		</div>
		<div class="con" :style="{height:fixedHeight-82+'px'}">
			<div class="table">
				<el-table :data="breedplan" style="width: 100%" size="small">
					<el-table-column label="顾客" prop="user_info.user_name">
					</el-table-column>
					<el-table-column prop="user_info.user_mobile" label="手机号">
					</el-table-column>
					<el-table-column label="计划名称" >
						<template slot-scope="scope">
							<span>{{scope.row.gift_bag_info.title}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="pets_type.project_name" label="计划等级">
						<template slot-scope="scope">
							<span>{{scope.row.gift_bag_info.gift_bag_level.title}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="surplus_count" label="剩余计划次数">
					</el-table-column>
					<el-table-column prop="pets_breed" label="状态">
						<template slot-scope="scope">
							<span v-if="scope.row.status==1">进行中</span>
							<span v-if="scope.row.status==2">发货中</span>
							<span v-if="scope.row.status==3">已完成</span>
						</template>
					</el-table-column>
					<el-table-column  label="下一次发货时间">
						<template slot-scope="scope">
							<span > {{$public.FTime(scope.row.next_shipments_time,'YYYY-MM-DD')}}</span>
						
						</template>
					</el-table-column>
					
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<el-button v-if="scope.row.status!=3" type="text" size="small" @click='edit(scope.row._id)'>编辑
							</el-button>
							<el-button v-if="scope.row.status==3" type="text"  size="small"
								@click='seedetail(scope.row._id)'>查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page :total="total" :page="params.page_index" :pageSize='params.page_size' @change="changePage" style="padding: 10px 0;"></page>
			</div>
		</div>
	
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	
	import {
		getbreedplan,
		
	} from '../../../api/program.js'
	export default {
		components: {
			page
		},
		data() {
			return {
				params: {
					page_index: 1,
					page_size: 12,
					keyword:'',
				},
				total: 0,
				categoryData: [],
				isHighlight: true,
				breedplan:[],
				petType:[],
				dialogGiftbag:false,
				fixedHeight:''
			}
		},
		methods: {
			getbreedplan() {
				getbreedplan(this.params).then(res => {
					if (res.code == 0) {
						this.breedplan = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			changePage(val) {
				this.params.pageIndex = val;
				this.getbreedplan();
			},
			clickSearch(){
				this.params.page_index = 1;
				this.getbreedplan();
			},
			
			edit(id){
				this.$router.push({path:'/breedplan/edit',query:{id}})
			},
			seedetail(id){
				this.$router.push({path:'/breedplan/detail',query:{id}})
			}
		},
		created() {
			this.getbreedplan();
			this.fixedHeight = document.documentElement.clientHeight - 86;
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.searchbox{
		font-size: 14px;
		display: flex;
		align-items: center;
		height: 72px;
		background: #fff;
		padding: 0 10px;
	}
	.con {
		display: flex;
		margin-top: 10px;
		.table {
			flex: 1;
			background-color: #fff;
		}
	}
</style>
